<template>
  <button
      class="btn btn-primary"
      @click.prevent="previewGroupCoachingBill">
    {{ $t('general.print') }}
  </button>
</template>

<script setup>
import { downloadFile } from '@/shared/functions';
import { defineProps, toRefs } from 'vue';

const props = defineProps({
  coachId: {
    type: Number,
    require: true,
  },
  filters: {
    type: Object,
    required: true,
  },
  coachBillingType: {
    type: String,
    required: true,
  },
  cost: {
    type: String,
    require: false,
  },
});

const { filters, coachId, coachBillingType, cost } = toRefs(props);

const previewGroupCoachingBill = () => {
  if (coachBillingType.value === 'pauschalbetrag') {
    downloadFile(
        `/coach-billing/group-coaching/preview-pauschal-bill/${coachId.value}`,
        undefined, filters.value,
    );
  } else {
    downloadFile(
        `/coach-billing/group-coaching/preview-hourly-wages-bill/${coachId.value}/${cost.value}`,
        undefined, filters.value,
    );
  }
};


</script>
